module.exports = __webpack_public_path__ + "img/001.6e5dcd5b.jpg";